import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Button from "../../../../../components/Button";
import SimpleTable from "../../../../../components/SimpleTable";
import { useColumns } from "./useColumns";

export function DeleteAllocationModal({ isOpen, close, allocationChanges, onConfirm }) {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);

	const columns = useColumns();

	const data = useMemo(
		() => (allocationChanges || []).map((row) => ({ ...row, id: row.allocation.id })),
		[allocationChanges],
	);

	const confirm = useCallback(async () => {
		setLoading(true);
		try {
			await onConfirm();
			close();
		} finally {
			setLoading(false);
		}
	}, [onConfirm, close]);

	return (
		<Modal backdrop isOpen={isOpen} centered size="lg">
			<ModalHeader className="d-flex flex-column align-items-center py-3 w-100">
				<FontAwesomeIcon
					icon={faTrash}
					className="text-danger w-100 mb-3"
					fontSize={40}
				/>
				<h2 className="mb-0 text-center font-weight-bolder">
					{t("are-you-sure")}
				</h2>
			</ModalHeader>

			<ModalBody className="py-0 px-4">
				<p className="mb-3 text-center">
					{t("working-shift-delete-allocation-changes-intro")}
				</p>

				<div className="mb-3 overflow-auto" style={{ maxHeight: "40vh" }}>
					<SimpleTable data={data} columns={columns} footer={false} />
				</div>
			</ModalBody>

			<ModalFooter className="d-flex justify-content-center mb-3">
				<Button color="light" onClick={close} disabled={loading}>
					{t("cancel")}
				</Button>
				<Button color="danger" onClick={confirm} loading={loading}>
					{t("confirm")}
				</Button>
			</ModalFooter>
		</Modal>
	);
}
